const language = {
    'pt': 
        {
            articles:                   'Notícias',
            articles_list:              'Lista de artigos',
            article_new:                'Novo artigo',
            attributes:                 'Atributos',
            attributes_list:            'Lista de atributos',
            attribute_new:              'Novo atributo',
            attribute_values:           'Valores',
            attribute_values_list:      'Lista de Valores',
            attribute_value_new:        'Novo valor',
            banners:                    'Banners',
            banners_list:               'Lista de banners',
            banner_new:                 'Novo banner',
            brands:                     'Marcas',
            brands_list:                'Lista de marcas',
            brand_new:                  'Nova marca',
            calendar:                   'Calendário',
            carrier_list:               'Lista de Transportadoras',
            categories:                 'Categorias',
            categories_list:            'Lista de categorias',
            category_new:               'Inserir categoria',
            choose_option:              'Escolher',
            content:                    'Conteúdo',
            content_list:               'Lista de conteúdos',
            content_new:                'Novo conteúdo',
            contest:                    'Concurso',
            contest_list:               'Lista de inscritos',
            contest_new:                'Novo inscrito',
            country_list:               'Lista de países',
            estancia:                   'Estância',
            estancia_aulas:             'Marcação de Aulas',
            estancia_aulas_list:        'Lista de aulas',
            estancia_aulas_new:         'Inserir aula',
            estancia_aulas_add:         'Adicionar aula',
            estancia_aulas_info:             'Aulas',
            estancia_aulas_info_list:        'Lista de aulas',
            estancia_aulas_info_new:         'Inserir aula',
            estancia_aulas_info_add:         'Adicionar aula',
            estancia_aulas_cliente:     'Agendar Aula',
            estancia_config:            'Gestão de pistas',
            estancia_meios:             'Meios Mecânicos',
            estancia_meios_list:        'Lita de meios mecânicos',
            estancia_meio_new:          'Inserir meio',
            estancia_meio_add:          'Adicionar meio',
            estancia_pistas:            'Pistas',
            estancia_pistas_list:       'Lista pistas',
            estancia_pista_new:         'Inserir pista',
            estancia_pista_add:         'Adicionar pista',
            estancia_forfaits:          'Forfaits',
            estancia_forfaits_list:     'Lista forfaits',
            estancia_forfait_new:       'Inserir forfait',
            estancia_forfait_add:       'Adicionar forfait',
            estancia_equipamentos:      'Equipamentos',
            estancia_equipamentos_list: 'Lista equipamentos',
            estancia_equipamento_new:   'Inserir equipamento',
            estancia_equipamento_add:   'Adicionar equipamento',
            estancia_vouchers:          'Vouchers',
            estancia_vouchers_list:     'Lista vouchers',
            estancia_voucher_new:       'Inserir voucher',
            estancia_voucher_add:       'Adicionar voucher',
            estancia_packs:             'Packs',
            estancia_packs_list:        'Lista progrmas',
            estancia_pack_new:          'Inserir pack',
            estancia_pack_add:          'Adicionar pack',
            estancia_activities:        'Atividades',
            estancia_activities_list:   'Lista atividades',
            estancia_activities_new:    'Inserir atividade',
            estancia_activities_add:    'Adicionar atividade',
            estancia_zonas:             'Zonas',
            estancia_zonas_list:        'Lista zonas',
            estancia_zona_new:          'Inserir zona',
            estancia_zona_add:          'Adicionar zona',
            estancia_instrutores:       'Instrutores',
            estancia_colaboradores:     'Colaboradores',
            estancia_parametros:        'Parâmetros',
            estancia_produtos:          'Produtos',
            features:                   'Características',
            features_list:              'Lista de características',
            feature_new:                'Nova característica',
            feature_values:             'Valores',
            feature_values_list:        'Lista de Valores',
            feature_value_new:          'Novo valor',
            galleries:                  'Galerias',
            galleries_list:             'Lista de galerias',
            gallery_new:                'Inserir galeria',
            menus:                      'Menus',
            menus_list:                 'Lista de menus',
            menu_new:                   'Inserir menu',
            my_data:                    'Os meus dados',
            painel_principal:           'Painel Principal',
            normas_submissao:           'Normas de submissão',
            evento:                     'Evento',
            lista_eventos:              'Lista de Eventos',
            inserir_evento:             'Inserir Evento',
            call_for_papers:            'Call for papers',
            lista_cfp:                  'Lista de Cfp',
            inserir_cfp:                'Inserir Cfp',
            perfis:                     'Perfis',
            lista_perfis:               'Lista de perfis',
            inserir_perfil:             'Novo perfil',
            novo:                       'Novo',
            autor:                      'Autor',
            lista_autores:              'Lista de autores',
            revisor:                    'Revisor',
            lista_revisores:            'Lista de revisores',
            editor:                     'Editor',
            lista_editores:             'Lista de editores',
            artigo:                     'Artigo',
            novo_artigo:                'Adicionar artigo',
            lista_artigos:              'Lista de artigos',
            conteudo_site:              'Conteúdo site',
            conteudo:                   'Conteúdo',
            novo_conteudo:              'Novo conteúdo',
            difusao_cientifica:         'Difusão',
            revista:                    'Revista',
            conferencia:                'Conferência',
            nova_difusao:               'Nova difusão',
            termos:                     'Termos',
            termos_condicoes:           'Termos e condições',
            store:                      'Loja Online',
            store_products:             'Produtos',
            store_products_list:        'Lista de Produtos',
            store_product_new:          'Inserir Produtos',
            store_product_add:          'Adicionar Produtos',
            projects:                   'Projectos',
            project_areas:              'Ýreas temáticas',
            project_areas_list:         'Lista de áreas',
            project_area_new:           'Inserir área',
            project_area_add:           'Adicionar áreas',
            project_domains:            'Domínios',
            project_domains_list:       'Lista de Domínios',
            project_domain_new:         'Inserir domínio',
            project_domain_add:         'Adicionar domínio',
            project_funds:              'Fundos',
            project_funds_list:         'Lista de Fundos',
            project_fund_new:           'Inserir fundo',
            project_fund_add:           'Adicionar fundo',
            project_parameters:         'Parâmetros',
            project_programs:           'Packs',
            project_programs_list:      'Lista de packs',
            project_program_new:        'Inserir pack',
            project_program_add:        'Adicionar pack',
            project_scopes:             'Âmbito Territorial',
            project_scopes_list:        'Lista de âmbitos',
            project_scope_new:          'Inserir âmbito',
            project_scope_add:          'Adicionar âmbito',
            politica_privacidade:       'Política de privacidade',
            purchase_order:             'Encomendas',
            purchase_order_p:           'Encomendas pagas',
            purchase_order_u:           'Encomendas usadas',
            purchase_order_nu:          'Encomendas não usadas',
            store_parameters:           'Parâmetros',
            store_shipping:             'Envio',
            taxe_list:                  'Lista de taxas',
            testemonies:                'Testemunhos',
            testemonies_list:           'Lista de testemunhos',
            testemony_new:              'Inserir testemunho',
            webuser:                    'Utilizadores',
            webuser_list:               'Lista de utilizadores',
            webuser_new:                'Inserir utilizador',
            client:                     'Cliente',
            company:                    'Empresa',
            client_list:                'Lista de clientes',
            client_new:                 'Inserir cliente',
            zone_list:                  'Lista de zonas',
        },
    'en':
        {
            articles:                   'News',
            articles_list:              'Articles list',
            article_new:                'New article',
            attributes:                 'Attributes',
            attributes_list:            'Attributes list',
            attribute_new:              'New attribute value',
            attribute_values:           'Attribute values',
            attribute_values_list:      'Attribute values list',
            attribute_value_new:        'New attribute value',
            banners:                    'Banners',
            banners_list:               'Banners List',
            banner_new:                 'New banner',
            brands:                     'Brands',
            brands_list:                'Brands list',
            brand_new:                  'New brand',
            calendar:                   'Calendar',
            carrier_list:               'Carrier list',
            categories:                 'Categories',
            categories_list:            'Categories list',
            category_new:               'Insert category',
            choose_option:              'Choose',
            content:                    'Content',
            content_list:               'Content List',
            content_new:                'Insert content',
            contest:                    'Contest',
            contest_list:               'Subscription list',
            contest_new:                'New subscription',
            country_list:               'Country list',
            estancia:                   'Resort',
            estancia_aulas:             'Classes',
            estancia_aulas_list:        'Class list',
            estancia_aulas_new:         'Insert class',
            estancia_aulas_add:         'Add class',
            estancia_config:            'Gestão',
            estancia_meios:             'Meios Mecânicos',
            estancia_meios_list:        'Lita de meios mecânicos',
            estancia_meio_new:          'Inserir meio',
            estancia_meio_add:          'Adicionar meio',
            estancia_pistas:            'Pistas',
            estancia_pistas_list:       'Lita pistas',
            estancia_pista_new:         'Inserir pista',
            estancia_pista_add:         'Adicionar pista',
            estancia_forfaits:          'Forfaits',
            estancia_forfaits_list:     'Lista forfaits',
            estancia_forfait_new:       'Inserir forfaits',
            estancia_forfait_add:       'Adicionar forfait',
            estancia_equipamentos:      'Equipamentos',
            estancia_equipamentos_list: 'Lista equipamentos',
            estancia_equipamento_new:   'Inserir equipamento',
            estancia_equipamento_add:   'Adicionar equipamento',
            estancia_vouchers:          'Vouchers',
            estancia_vouchers_list:     'Lista vouchers',
            estancia_voucher_new:       'Inserir voucher',
            estancia_voucher_add:       'Adicionar voucher',
            estancia_packs:             'Packs',
            estancia_packs_list:        'Lista progrmas',
            estancia_pack_new:          'Inserir pack',
            estancia_pack_add:          'Adicionar pack',
            estancia_activities:        'Experiências',
            estancia_activities_list:   'Lista experiências',
            estancia_activities_new:    'Inserir experiência',
            estancia_activities_add:    'Adicionar experiência',
            estancia_zonas:             'Zonas',
            estancia_zonas_list:        'Lista zonas',
            estancia_zona_new:          'Inserir zona',
            estancia_zona_add:          'Adicionar zona',
            estancia_instrutores:       'Instrutores',
            estancia_colaboradores:     'Colaboradores',
            estancia_parametros:        'Parâmetros',
            estancia_produtos:          'Produtos',
            features:                   'Features',
            features_list:              'Features list',
            feature_new:                'Insert feature',
            feature_values:             'Feature values',
            feature_values_list:        'Feature values list',
            feature_value_new:          'New feature value',
            galleries:                  'Galleries',
            galleries_list:             'Galleries List',
            gallery_new:                'Insert gallery',
            menus:                      'Menus',
            menus_list:                 'Menus list',
            menu_new:                   'Insert menu',
            my_data:                    'Os meus dados',
            painel_principal:           'Dashboard' ,
            normas_submissao:           'Submission rules',
            evento:                     'Event',
            lista_eventos:              'Events list',
            inserir_evento:             'Add Event',
            call_for_papers:            'Call for papers',
            lista_cfp:                  'Cfp list',
            inserir_cfp:                'Add Cfp',
            perfis:                     'Profiles',
            lista_perfis:               'Profiles list',
            inserir_perfil:             'Add profile',
            novo:                       'Add',
            autor:                      'Author',
            lista_autores:              'Authors list',
            revisor:                    'Reviewer',
            lista_revisores:            'Reviewers list',
            editor:                     'Publisher',
            lista_editores:             'Publishers list',
            artigo:                     'Article',
            novo_artigo:                'Add article',
            lista_artigos:              'Articles list',
            conteudo_site:              'Content site',
            conteudo:                   'Content',
            novo_conteudo:              'Add content',
            difusao_cientifica:         'Dissemination',
            revista:                    'Journal',
            conferencia:                'Conference',
            nova_difusao:               'Add dissemination',
            termos:                     'Terms',
            termos_condicoes:           'Terms and conditions',
            store:                      'Online Store',
            store_products:             'Products',
            store_products_list:        'Products List',
            store_product_new:          'Insert Product',
            store_product_add:          'Add Product',
            projects:                   'Projects',
            project_areas:              'Thematic areas',
            project_areas_list:         'Areas List',
            project_area_new:           'Insert area',
            project_area_add:           'Add area',
            project_domains:            'Domains',
            project_domains_list:       'Domains List',
            project_domain_new:         'Insert domain',
            project_domain_add:         'Add domain',
            project_funds:              'Funds',
            project_funds_list:         'Funds List',
            project_fund_new:           'Insert fund',
            project_fund_add:           'Add fund',
            project_parameters:         'Parameters',
            store_shipping:             'Shipping',
            project_programs:           'Programs',
            project_programs_list:      'Programs List',
            project_program_new:        'Insert program',
            project_program_add:        'Add program',
            project_scopes:             'Territorial Scopes',
            project_scopes_list:        'Scopes List',
            project_scope_new:          'Insert scope',
            project_scope_add:          'Add scope',
            politica_privacidade:       'Privacy policy',
            purchase_order:             'Encomendas',
            purchase_order_p:           'Encomendas pagas',
            purchase_order_u:           'Encomendas usadas',
            purchase_order_nu:          'Encomendas não usadas',
            store_parameters:           'Parameters',
            taxe_list:                  'Taxe List',
            testemonies:                'Testimonials',
            testemonies_list:           'Testimonials List',
            testemony_new:              'Insert Testimonial',
            webuser:                    'User',
            webuser_list:               'Users list',
            webuser_new:                'Insert user',
            client:                     'Clientes',
            client_list:                'Lista de clientes',
            client_new:                 'Inserir cliente',
            zone_list:                  'Zone list',
        }
}

module.exports = {
    language
};
